import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './images/minslide-product.jpg';
import _imports_1 from './images/slide-product.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ea8ef974"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "container-fluild"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "row long-row"
  }, [/*#__PURE__*/_createElementVNode("img", {
    class: "minImg",
    src: _imports_0,
    alt: "product"
  }), /*#__PURE__*/_createElementVNode("img", {
    class: "maxImg",
    src: _imports_1,
    alt: "product"
  })])], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_router_view)], 64);
}